import PartnersBusiness from 'sly/partners/business';

export const getServerSideProps = () => ({ props: {} });

export default PartnersBusiness;
